import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { dashboardTokens } from "./dashboardStyles";

/**
 * Cabeçalho de seção padrão: título + subtítulo opcional + ação opcional no
 * canto direito (ex.: "Ver todos"). Só chrome, sem lógica.
 */
function DashboardSection({ title, subtitle, action, children, sx }) {
  return (
    <Box sx={{ mb: 3.5, ...sx }}>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
        spacing={1}
        sx={{ mb: 1.5, pb: 1.25, borderBottom: `1px solid ${dashboardTokens.border}` }}
      >
        <Box>
          <Typography sx={{ fontSize: "1rem", fontWeight: 600, color: "#1e1e1e" }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: "0.8rem", color: dashboardTokens.textSecondary, mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
      </Stack>
      {children}
    </Box>
  );
}

export default DashboardSection;
